import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import GradeLabel from '../grade'
import { Pencil } from 'react-bootstrap-icons'

const ViewGrade = ({
    user = {},
    onEdit = () => {},
    disabled
}) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
                <GradeLabel user={user} />
            </div>
            <div>
                {!disabled && <div style={{ cursor: 'pointer' }} onClick={() => onEdit()} ><Pencil /></div>}
            </div>
        </div>
    )
}

export default ViewGrade